import { render, staticRenderFns } from "./DetectionFaultFilter.vue?vue&type=template&id=3a0cf47f"
import script from "./DetectionFaultFilter.vue?vue&type=script&lang=js"
export * from "./DetectionFaultFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports